import { NavigationContainer as RNNavigationContainer } from '@react-navigation/native'
import React, { useCallback, useEffect, useRef } from 'react'

import * as constants from 'utils/constants'
import { analytics, logEvent } from 'utils/firebase'

import { useAuth } from 'contexts/AuthContext'

import { linking } from './linking'

export const NavigationContainer = ({ children, drawerNavigationRef }: any) => {
  const routeNameRef = useRef('')
  const currentRoute = drawerNavigationRef.isReady() ? drawerNavigationRef.getCurrentRoute() : null
  const currentRouteName = currentRoute?.name

  const logViewInAnalytics = useCallback(() => {
    if (constants.platform.IS_WEB) {
      const pageLocation = window.location.href
      logEvent(analytics, 'page_view', {
        page_title: currentRouteName,
        page_location: pageLocation,
        page_path: pageLocation,
      })
    }

    logEvent(analytics, 'screen_view', {
      firebase_screen: currentRouteName,
      firebase_screen_class: currentRouteName,
    })
  }, [currentRouteName])

  useEffect(() => {
    logViewInAnalytics()
  }, [logViewInAnalytics])

  const handleStateChange = useCallback(async () => {
    const previousRouteName = routeNameRef.current
    if (previousRouteName !== currentRouteName) logViewInAnalytics()

    // Save the current route name for later comparison
    if (currentRouteName) routeNameRef.current = currentRouteName
  }, [currentRouteName, logViewInAnalytics])

  const { setInitialRoute } = useAuth()

  return (
    <RNNavigationContainer
      ref={drawerNavigationRef}
      linking={linking(setInitialRoute)}
      onStateChange={handleStateChange}
    >
      {children}
    </RNNavigationContainer>
  )
}
